module.exports = __webpack_public_path__ + "assets/white-left-arrow-hp-f55b92.svg";